import React from "react";
import { Alert, Stack, Text, Title } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import { HotelBookingDto } from "../../api/hotelBookingApi";
import BookingCard from "./BookingCard";
import BookingFilters from "./BookingFilters";
import { BookingAction, HotelBookingTexts } from "./HotelBookingTypes";

type Props = {
    bookings: HotelBookingDto[];
    loading: boolean;
    search: string;
    statusFilter: string | null;
    onSearchChange: (value: string) => void;
    onStatusFilterChange: (value: string | null) => void;
    t: HotelBookingTexts & {
        myBookings: string;
        myBookingsText: string;
        noBookings: string;
    };
    language: "en" | "da";
    onView: BookingAction;
    onPay: BookingAction;
    onRooming: BookingAction;
};

export default function BookingList({
    bookings,
    loading,
    search,
    statusFilter,
    onSearchChange,
    onStatusFilterChange,
    t,
    language,
    onView,
    onPay,
    onRooming,
}: Props) {
    return (
        <Stack gap="md">
            <Stack gap={2}>
                <Title order={4}>{t.myBookings}</Title>
                <Text c="dimmed" size="sm">{t.myBookingsText}</Text>
            </Stack>

            <BookingFilters
                search={search}
                statusFilter={statusFilter}
                onSearchChange={onSearchChange}
                onStatusFilterChange={onStatusFilterChange}
                language={language}
            />

            {loading ? (
                <Text c="dimmed">Loading...</Text>
            ) : bookings.length === 0 ? (
                <Alert icon={<IconAlertCircle size={18} />} color="blue" variant="light">
                    {search || (statusFilter && statusFilter !== "all")
                        ? language === "en"
                            ? "No bookings match your filter."
                            : "Ingen bookinger matcher dit filter."
                        : t.noBookings}
                </Alert>
            ) : (
                bookings.map((booking) => (
                    <BookingCard
                        key={booking.hotelBookingID}
                        booking={booking}
                        t={t}
                        language={language}
                        onView={onView}
                        onPay={onPay}
                        onRooming={onRooming}
                    />
                ))
            )}
        </Stack>
    );
}
